import { useAppUpdate } from "../lib/app-update.tsx";

/**
 * One quiet line on the log and the overview when a newer Babia is live
 * (lib/app-update.tsx). It sits in the page, so it never covers a sheet, and
 * it shows in night mode too: a fix can matter at 3am. Refresh waits for any
 * write in flight, then reloads.
 */
export function UpdateNotice() {
  const { newer, reload, reloading } = useAppUpdate();
  if (!newer) return null;
  return (
    <p role="status" className="mt-3 text-[14px]">
      <span className="opacity-70">A new version of Babia is ready.</span>{" "}
      <button
        type="button"
        className="-my-3 inline-block py-3 underline underline-offset-2"
        disabled={reloading}
        onClick={() => reload("notice")}
      >
        {reloading ? "Refreshing…" : "Refresh"}
      </button>
    </p>
  );
}
